<div class="social-sidebar">
  <ul>
    <!-- <li><a target="_blank" href="https://www.facebook.com/XaoZzz/">Facebook</a></li> -->
    <li><a target="_blank" href="https://www.linkedin.com/in/alex-mamaev-developer">Linkedin</a></li>
  </ul>
</div>
